import api from "../../utils/Api";

const BackendAdminApiBaseUrl = process.env.REACT_APP_ADMIN_URL;
const candidateApi = {    
    async listCandidate(data){
        const response = await api.get( BackendAdminApiBaseUrl + '/talent/' + data);
        return response;
    },

    async suggestionCandidate(data){
        const response = await api.get( BackendAdminApiBaseUrl + '/employer/suggestionTalent/'+ data);
        return response;
    },

    async suggestionCandidateCampaign(data){
        const response = await api.get( BackendAdminApiBaseUrl + '/talent/suggestion/Campagin'+ data);
        return response;
    },

    async typeCandidate(data){
        const response = await api.get( BackendAdminApiBaseUrl + '/talent/Filter/PrivateEmp'+ data);
        return response;
    },

    async filterCandidate(data){
        const response = await api.get( BackendAdminApiBaseUrl + '/talent/Filter/Details/' + data);
        return response;
    },

    async removeCandidate(data){
        const response = await api.patch( BackendAdminApiBaseUrl + '/talent/removeEmployeeAssociation/' + data.empId + '/' + data.candId);
        return response;
    }
}

export default candidateApi;